export const Units = 1;
export const Categories = 2;
export const Products = 3;
export const Activities = 4;
